import { BankovniUcet } from './bankovniUcet';
import { DokladSk } from './dokladsk';
import { SazbaDph } from './dphsazba';
import { DruhDokladu } from './druhDokladu';
import { KategoriePrac } from './kategoriePrac';
import { Mena } from './mena';
import { MenaKurz } from './menakurz';
import { NakladoveStredisko } from './nakladoveStredisko';
import { NakladoveStrediskoTyp } from './nakladoveStrediskoTyp';
import { Pokladna } from './pokladna';
import { ReklamaText } from './reklamaText';
import { Stanoviste } from './stanoviste';
import { Stat } from './stat';
import { Texty } from './texty';
import { Tymprac } from './tymprac';
import { ZakazkaDruh } from './zakazkaDruh';
import { EmailText } from './emailText';
import { SmsText } from './smsText';
import { DokladCiselnaRada } from './dokladCiselnaRada';

export const menu = {
	name: 'CiselnikFiremni',
	list: [
		{ name: 'NaklStred', route: NakladoveStredisko.name },
		{ name: 'Mena', route: Mena.name },
		{ name: 'KategoriePrac', route: KategoriePrac.name },
		{ name: 'BankovniUcet', route: BankovniUcet.name },
		{ name: 'DruhDokladu', route: DruhDokladu.name },
		{ name: 'Reklamatext', route: ReklamaText.name },
		{ name: 'Stat', route: Stat.name },
		{ name: 'MenaKurz', route: MenaKurz.name },
		{ name: 'Dphsazba', route: SazbaDph.name },
		{ name: 'Dokladsk', route: DokladSk.name },
		{ name: 'SZakazkadruh', route: ZakazkaDruh.name },
		{ name: 'Stanoviste', route: Stanoviste.name },
		{ name: 'Tymprac', route: Tymprac.name },
		{ name: 'Pokladna', route: Pokladna.name },
		{ name: 'NakladoveStrediskoTyp', route: NakladoveStrediskoTyp.name },
		{ name: 'Texty', route: Texty.name },
		{ name: 'EmailText', route: EmailText.name },
		{ name: 'SmsText', route: SmsText.name },
		{ name: 'SpravaCR', route: DokladCiselnaRada.name },
	],
};
